import { Link } from 'react-router'
import { StatusBadge, type StatusTone } from '@/components/ui/status-badge'
import { Surface } from '@/components/ui/surface'
import { previewOf, useOpenCaptures } from './useOpenCaptures'
import type { CaptureStatus } from './types'

const STATUS: Partial<Record<CaptureStatus, { label: string; tone: StatusTone }>> = {
  concept: { label: 'Concept', tone: 'neutral' },
  verwerken: { label: 'Wordt verwerkt', tone: 'info' },
  klaar: { label: 'Klaar om te controleren', tone: 'success' },
  mislukt: { label: 'Verwerken mislukt', tone: 'warning' },
}

/** "Openstaand": the user's own concepts and processings that are not confirmed yet. */
export function OpenCaptures({ excludeId }: { excludeId?: string | undefined }) {
  const { captures } = useOpenCaptures(true)
  const shown = captures.filter((capture) => capture.id !== excludeId)
  if (shown.length === 0) return null
  return (
    <section aria-labelledby="inspreken-openstaand" className="space-y-2">
      <h2 id="inspreken-openstaand" className="text-base font-semibold">
        Openstaand
      </h2>
      <ul className="space-y-2">
        {shown.map((capture) => {
          const status = STATUS[capture.status]
          return (
            <li key={capture.id}>
              <Surface asChild variant="inset" padding="sm">
                <Link
                  to={`/relaties/inspreken/${capture.id}`}
                  className="flex min-h-11 items-center justify-between gap-3"
                >
                  <span className="min-w-0 truncate text-base">{previewOf(capture) || 'Leeg concept'}</span>
                  {status ? <StatusBadge tone={status.tone}>{status.label}</StatusBadge> : null}
                </Link>
              </Surface>
            </li>
          )
        })}
      </ul>
    </section>
  )
}
